import MIMachineFault from "../MIMachineFault";
import MIOrderHistory from "../MIOrderHistory";

// Map views to their respective components
export const viewMappings = {
  faults: MIMachineFault,
  orders: MIOrderHistory, // Example - create OrdersComponent accordingly
  // Add additional mappings here as you add new views
};

export function getViewComponent(view) {
  return viewMappings[view] || null; // Fallback to DefaultComponent
}
